///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../common/collection-api.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportEmployeeCategory = Meevo.Plugins.Reports.IReportEmployeeCategory;

    export class ReportEmployeeCategoriesCollection extends SmartMoverApiCollection<IReportEmployeeCategory> implements IApiCollection<IReportEmployeeCategory> {

        protected get url() {
            return 'Report/EmployeeCategory';
        }
    }

}